import { LinkedInPreview } from "./LinkedInPreview";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface PreviewPanelProps {
  content: string;
  images: string[];
  video: string | null;
  onImageRemove?: (imageUrl: string) => void;
  onVideoRemove?: () => void;
}

export const PreviewPanel = ({ 
  content, 
  images, 
  video,
  onImageRemove,
  onVideoRemove 
}: PreviewPanelProps) => {
  const [profilePicture, setProfilePicture] = useState<string | null>(null);
  const [linkedinName, setLinkedinName] = useState<string | null>(null);
  const [linkedinHeadline, setLinkedinHeadline] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data: profile } = await supabase
        .from('profiles')
        .select('linkedin_picture, linkedin_name, linkedin_headline')
        .eq('id', user.id)
        .single() as { data: { 
          linkedin_picture: string | null;
          linkedin_name: string | null;
          linkedin_headline: string | null;
        } | null };

      if (profile?.linkedin_picture) {
        setProfilePicture(profile.linkedin_picture);
      }
      if (profile?.linkedin_name) {
        setLinkedinName(profile.linkedin_name);
      }
      if (profile?.linkedin_headline) {
        setLinkedinHeadline(profile.linkedin_headline);
      }
    };

    fetchProfile();
  }, []);

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <h3 className="text-sm font-medium p-4 border-b border-gray-200">Preview</h3>
      <LinkedInPreview 
        content={content} 
        images={images}
        video={video}
        onImageRemove={onImageRemove}
        onVideoRemove={onVideoRemove}
        profilePicture={profilePicture}
        linkedinName={linkedinName}
        linkedinHeadline={linkedinHeadline}
      />
    </div>
  );
};